import React from "react";
import { DistanceValueUnit } from "../../enums/configuration/units";
import useDistanceUnitValue from "../../hooks/useDistanceUnitValue";

const DistanceUnitSet: React.FC<{value: number, valueUnit: DistanceValueUnit, round?:boolean}> = ({value, valueUnit, round}) => {
    const {converted, label} = useDistanceUnitValue(value, valueUnit, round);

    return <React.Fragment>{`${converted} ${label}`}</React.Fragment>;
}

export default DistanceUnitSet